import styled from 'styled-components';

export default styled.hr`
  border: 0;
  margin: 0;
  padding: calc(var(--item-x-margin) / 2) 0;
`;
